import 'react-app-polyfill/stable';
import 'configs/fonts';
import 'configs/i18n';
import 'configs/logger';
import 'styles/variables.css';
import 'styles/index.css';
import 'styles/override.css';

import React, { Suspense } from 'react';

import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { ConfigProvider } from 'antd';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { RouterProvider } from 'react-router-dom';

import ErrorFallback from 'components/error-fallback';
import FullscreenSpinner from 'components/fullscreen-spinner';
import { persister, queryClient } from 'configs/query';
import 'components/alert-box';
import { initRUM } from 'configs/rum';
import RegisterSW from 'configs/serviceWorker';
import { theme } from 'configs/theme';
import { router } from 'router';
import { initializeAnalytics } from 'services/analytics';
import { installGlobalErrorHandlers } from 'services/errorService';

initRUM();
initializeAnalytics();
installGlobalErrorHandlers();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <RegisterSW />
      <ConfigProvider theme={theme}>
        <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
          <Suspense fallback={<FullscreenSpinner />}>
            <RouterProvider router={router} />
          </Suspense>
        </PersistQueryClientProvider>
      </ConfigProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
